import React, { useEffect } from "react"
import { ImageImgButton } from "./SingleButtton"
import { ReactComponent as SearchSvg } from "../style/images/btn_search.svg"
import { useFormContext } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleUp, faAngleDown, faXmark } from "@fortawesome/free-solid-svg-icons"

const InputBox = ({usage, type, id, placeholder, value, onChange}) => {
  if (type === undefined) type = 'text'
  return (
    <div className={`${usage}_input`}>
      <input type={type} id={id} placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  )
}

const SearchBox = ({placeholder}) => {
  return (
    <div className="search">
      <input type="text" placeholder={placeholder} />
      {/*TODO: Search Button*/}
      <SearchSvg className="search_icon" /> 
    </div>
  )
}

const FormSelectionBox = ({name, options, optionTags, placeholder=""}) => {
  const { register } = useFormContext()
  return (
    <select {...register(name)} placeholder={placeholder}>
      {options.map((e, i) => {
        return <option value={e}>{optionTags[i]}</option>
      })}
    </select>
  )
}

const SingleSelectionBox = ({options, handleOnChange, placeholder='', value}) => {
  return (
    <select value={value} placeholder={placeholder} onChange={handleOnChange}>
      {options.map((e) => {
        return <option value={e}>{e}</option>
      })}
    </select>
  )
}

const MultiSelectionBox = ({name, options, optionTagMap=false, long=false}) => {
  const form = useFormContext()
  const [displayOptions, setDisplayOptions] = React.useState(false)
  const handleOnClick = (evt) => {
    setDisplayOptions(!displayOptions)
  }
  const Chip = ({ text }) => {
    return <span className="chip-text-body">{text}</span>;
  }
  const displayChips = (content) => {
    if (content === undefined || !content) return [];
    return content.map((e) => {
      return <Chip key={e} text={e} />
    })
  }
  const controlSelectedTagColor = (e) => {
    if (form.watch(name) && form.watch(name).includes(e)) return { backgroundColor: '#3e9eff'}
    else return {}
  }
  return (
    <div className={long? "multi-selection-long-box":"multi-selection-box"} tabIndex={1000*Math.round(Math.random())} onBlur={()=>{setDisplayOptions(false)}}>
      <div className="msb-box-body">
        <div className="msb-box-selected">
          {displayChips(form.watch(name))}
        </div>
        <div className="msb-clear-all-btn" onClick={() => {form.setValue(name, [])}}>
          <FontAwesomeIcon icon={faXmark} />
        </div>
        <div className="msb-show-list-btn" onClick={handleOnClick}>
          {displayOptions ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
        </div>
      </div>
      <div
        className="msb-drop-down-lists"
        style={displayOptions ? { display: "block" } : { display: "none" }}
      >
        {options.map((e) => {
          return (
            <div className="msb-option" style={controlSelectedTagColor(e)}>
              <label key={`lb_${e}`} htmlFor={e}>
                <input
                  id={e}
                  type="checkbox"
                  {...form.register(name)}
                  value={e}
                  style={{display: 'none'}}
                />
                {optionTagMap? <span>{optionTagMap[e]} {e}</span>:<span>{e}</span>}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export { InputBox, SearchBox, FormSelectionBox, SingleSelectionBox, MultiSelectionBox }